import React from 'react';
import contact from './contact.module.css';
import service1 from '../../../Assets/Contact/map.png';
import service2 from '../../../Assets/Contact/email.png';
import service3 from '../../../Assets/Contact/phone.png';
import service4 from '../../../Assets/Contact/opening.png';
import defaultIMG from "../../../Assets/defaultimg.png";


const Contactpage2 = () => {
    return (
        <div className={contact.container2}>
            <div className={contact.sub_container2}>
                <div className={contact.services}>
                    <div className={contact.service_img_container}>
                        <img src={service1}
                           onError={({ currentTarget }) => {
                            currentTarget.onerror = null; 
                            currentTarget.src= defaultIMG ;
                          }}
                         alt="location" className={contact.img_service} />
                    </div>
                    <h4 className={contact.service_header}>Location</h4>
                    <p className={contact.service_text}>#501 16-2-M84, Rajashekhara Enclave, Dharma Reddy colony, Phase- 2, Hydernagar, Kukatpally, KPHB Colony, Hyderabad, Tirumalagiri, Telangana, India, 500085.</p>
                </div>
                <div className={contact.services}>
                    <div className={contact.service_img_container}>
                        <img src={service2}
                           onError={({ currentTarget }) => {
                            currentTarget.onerror = null; 
                            currentTarget.src= defaultIMG ;
                          }}
                         alt="email" className={contact.img_service} />
                    </div>
                    <h4 className={contact.service_header}>Email</h4>
                    <p className={contact.service_text}>kohereconnect@gmail.com</p>
                </div>
                <div className={contact.services}>
                    <div className={contact.service_img_container}>
                        <img src={service3}
                           onError={({ currentTarget }) => {
                            currentTarget.onerror = null; 
                            currentTarget.src= defaultIMG ;
                          }}
                         alt="quick help" className={contact.img_service} />
                    </div>
                    <h4 className={contact.service_header}>Quick Help</h4>
                    <p className={contact.service_text}>+91 9581163404/8142072779 </p>
                </div>
                <div className={contact.services}>
                    <div className={contact.service_img_container}>
                        <img src={service4} 
                           onError={({ currentTarget }) => {
                            currentTarget.onerror = null; 
                            currentTarget.src= defaultIMG ;
                          }}
                        alt="opening hours" className={contact.img_service} />
                    </div>
                    <h4 className={contact.service_header}>Opening Hours</h4>
                    <div className={contact.service_textcontainer}>
                        <p className={contact.service_text}>Monday - Friday</p>
                        <p className={contact.service_text}>09:00 AM - 05:00 PM</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contactpage2;
